import { Title_With_ID } from '@office/ui-kit'
import { Svg } from '@office/ui-kit/dist/shared/media/icons/_types'
import { Dispatch, SetStateAction } from 'react'

export enum NotificationTypeEnum {
  error = 'error',
  warning = 'warning',
  success = 'success',
}

export enum ContextPosition {
  bottomCenter = 'bottomCenter',
  onMouse = 'onMouse',
  bottomStart = 'bottomStart',
}

export interface Image_Props {
  img?: string
  defaultIcon: Svg
}

export interface Use_State_String_Props {
  setValue: Dispatch<SetStateAction<string>>
  value: string
}

export interface Use_State_Title_With_ID_Props {
  setValue: Dispatch<SetStateAction<Title_With_ID>>
  value: Title_With_ID
}
